<!--
    描述：新增/编辑 弹窗
    时间：2020-04-27
    Created by zwh
-->
<template>
	<div class="">
		<el-form :model="objectForm"
				 :rules="formRules"
				 ref="objectForm"
				 label-width="90px"
				 size="small">
			<!-- 添加字典组，编辑字典组：无所属字典 -->
			<el-form-item label="所属字典"
						  v-if="transObj.type.indexOf('Group') < 0"
						  prop="parentName"
						  :show-message="false">
				<el-input v-model="objectForm.parentName"
						  disabled
						  autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="字典名称"
						  prop="sname">
				<el-input v-model="objectForm.sname"
						  autocomplete="off"
						  :disabled="isDisabled"
						  :show-message="false"
						  placeholder="请输入"></el-input>
			</el-form-item>
			<el-form-item label="排序"
						  prop="sort">
				<el-input type="number"
						  v-model="objectForm.sort"
						  :disabled="isDisabled"
						  autocomplete="off"
						  placeholder="请输入"></el-input>
			</el-form-item>
			<el-form-item label="备注"
						  prop="remarks">
				<el-input type="textarea"
						  :rows="3"
						  :disabled="isDisabled"
						  placeholder="请输入内容"
						  v-model="objectForm.remarks">
				</el-input>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import { getInfoById, saveOrUpdate } from 'api/system/sys.js'

export default {
	props: {
		transObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			objectForm: {
				id: '',
				parentId: '',
				parentName: '',
				sname: '',
				sort: '',
				remarks: '',
			},
			formRules: {
				parentName: [
					{ required: true, message: '请输入...', trigger: 'blur' },
				],
				sname: [
					{ required: true, message: '请输入...', trigger: 'blur' },
				],
			},
			operateData: {},
		}
	},
	methods: {
		// 查看、编辑 回显数据
		initFormInfo() {
			let param = { id: this.transObj.id }
			getInfoById(param).then((res) => {
				let params = res.data
				params.startDate = new Date(res.data.startDate)
				this.objectForm = params
			})
		},

		// 保存项目
		doSave() {
			//let params = Object.assign({}, this.objectForm)
			let that = this
			this.$refs.objectForm.validate((valid) => {
				if (valid) {
					let param = this.objectForm
					saveOrUpdate(param).then((res) => {
						if (res.operationCode == 1) {
							that.$message({
								message: '保存成功',
								type: 'success',
							})
							//刷新菜单信息
							that.$emit('on-success')
						}
					})
				} else {
					//this.$message.error('请完善必填项信息！')
				}
			})
		},
	},
	created() {
		this.objectForm.id = this.transObj.id
		this.objectForm.parentId = this.transObj.parentId
		this.objectForm.parentName = this.transObj.parentName
		if (this.transObj.mode !== 'add') {
			// 初始渲染数据
			this.initFormInfo()
		}
	},
	computed: {
		// 是否可编辑
		isDisabled() {
			return this.transObj.mode === 'view' ? true : false
		},
	},
}
</script>

<style lang="less">
.el-form-item {
	margin-bottom: 15px !important;
}
</style>